export enum EventTypeEnum{
    Reservation,
    Accommodation,
    InHouse
}